// extracted by mini-css-extract-plugin
export var blog_date = "content-module--blog_date--l1JP8";
export var blog_date_padding = "content-module--blog_date_padding--AJshn";
export var blog_description = "content-module--blog_description--DILsY";
export var blog_title = "content-module--blog_title--Z8rPU";
export var content = "content-module--content--42Mdf";
export var content_space = "content-module--content_space--AXZs3";
export var padding_zero = "content-module--padding_zero--8mufw";